import { render, staticRenderFns } from "./MerchantStaffUpdateStatus.vue?vue&type=template&id=ad6bdbf2&scoped=true"
import script from "./MerchantStaffUpdateStatus.vue?vue&type=script&lang=js"
export * from "./MerchantStaffUpdateStatus.vue?vue&type=script&lang=js"
import style0 from "./MerchantStaffUpdateStatus.vue?vue&type=style&index=0&id=ad6bdbf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6bdbf2",
  null
  
)

export default component.exports